// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1MSDo","item":"PaymentsMobile_item__1_Pbz","label":"PaymentsMobile_label__3lXf6","amount":"PaymentsMobile_amount__2z2Jp"};